import notify from 'devextreme/ui/notify'
import { config } from '../config'

function error(message) {
  notify(message, 'error', config.errorDisplayTime)
}

function success(message) {
  notify(message, 'success', config.successDisplayTime)
}

function info(message) {
  notify(message, 'info', config.successDisplayTime)
}

export const show = { error, success, info }
